import { KeyStatsComponent } from "./key-stats"
import { PerformanceComponent } from "./performance"
import { ReportingComponent } from "./reporting"
import { TrainingComponent } from "./training"
import { FeedbackComponent } from "./feedback"
import { InternalNotesComponent } from "./internal-notes"

export default {
  KeyStatsComponent,
  PerformanceComponent,
  ReportingComponent,
  TrainingComponent,
  FeedbackComponent,
  InternalNotesComponent,
}
